import { Host, h } from '@stencil/core';
export class AibaSelfieContentModal {
  constructor() {
    this.handleNextCTAClick = (event) => {
      this.handlers && this.handlers.clickSelfieScreenHandler(event);
      this.showAgeConformationModel = true;
    };
    this.data = undefined;
    this.handlers = undefined;
    this.confirmBoxData = undefined;
    this.disableCTA = undefined;
    this.showAgeConformationModel = false;
  }
  componentWillLoad() {
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    else {
      this.data = this.data;
    }
    this.contentData = this.data;
  }
  closemodal() {
    this.showAgeConformationModel = false;
  }
  render() {
    var _a;
    return (h(Host, null, this.showAgeConformationModel && this.confirmBoxData && h("aiba-selfie-confirm-box", { handlers: this.handlers, data: this.confirmBoxData }), h("div", { class: "content-modal" }, this.contentData &&
      ((_a = this.contentData) === null || _a === void 0 ? void 0 : _a.elements.map(element => {
        var _a;
        if (element.name === 'aiba-label') {
          return (h("div", { class: "label" }, h("aiba-label", Object.assign({}, element['data']))));
        }
        if (element['name'] === 'selfie-confirm-box') {
          this.confirmBoxData = element.data;
          this.disableCTA = element.disableCTA;
        }
        if (element.name === 'buttonGroup') {
          return (h("div", { class: "selfie-button-wrapper" }, (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.elements.map(item => (h("div", { class: "previous" }, item.data._id === 'previous' && h("aiba-button", Object.assign({ handleClick: (e) => this.handlers && this.handlers.clickPreviousScreenHandler(e) }, item['data'])), item.data._id === 'next' && h("aiba-button", Object.assign({ handleClick: (e) => this.handleNextCTAClick(e), class: "nextBtn" }, item['data'])))))));
        }
        if (element.name === 'aiba-link') {
          return (h("div", { class: "aiba-link" }, h("aiba-link", Object.assign({ clickEvent: (event) => this.handlers && this.handlers.nextAssesmentHandler(event) }, element['data']))));
        }
      })))));
  }
  static get is() { return "aiba-selfie-content-modal"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-selfie-content-modal.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-selfie-content-modal.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "confirmBoxData": {},
      "disableCTA": {},
      "showAgeConformationModel": {}
    };
  }
  static get listeners() {
    return [{
        "name": "closemodal",
        "method": "closemodal",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-selfie-content-modal.js.map
